<template>
    <DraftsPanel/>
</template>

<script>
import DraftsPanel from './DraftsPanel'
export default {
    name: 'Drafts',
    components: {
        DraftsPanel
    }
}
</script>

<style>

</style>